import uploadS3 from '@/libs/uploadS3'
import * as musicMetadata from 'music-metadata-browser'

const isPublic = true
const SET_INPUT = 'SET_INPUT'
const SET_ATTACH = 'SET_ATTACH'
const DEL_ATTACH = 'DEL_ATTACH'
const SET_EXCEEDED = 'SET_EXCEEDED'

export default {
  namespaced: true,

  state: {
    input: {},
    files: [],
    isFileExceeded: false
  },
  getters: {
    isExceeded: (state) => state.isFileExceeded
  },

  actions: {
    setInput (ctx, { message, refId, refType }) {
      ctx.commit(SET_INPUT, { message, refId, refType })
    },

    setIsExceeded (ctx, exceeded) {
      ctx.commit(SET_EXCEEDED, exceeded)
    },

    async startUpload (ctx, { refId, refType, files }) {
      for (let index = 0; index < files.length; index++) {
        const file = files[index]
        const id = `${Date.now()}-${String(index).padStart(3, 0)}`
        const isMedia = String(file.type).includes('audio') || String(file.type).includes('video')
        const notSupported = String(file.type) === 'audio/ogg' || String(file.type) === 'video/mpeg'

        let fileExceeded = typeMaxSize(file)
        if (fileExceeded) newNotification('INFO', `${file.name} será gerado um link, tamanho excedido!`)

        let codec = file.codec ?? ''

        if (!codec && isMedia && !fileExceeded && !notSupported) {
          codec = await musicMetadata.parseBlob(file).then((meta) => meta?.format?.codec || '').catch(() => {
            fileExceeded = true
            return ''
          })
        }

        const attach = { id, fileName: file.name, fileSize: file.size, fileMimeType: file.type, refId, refType, progress: 0, codec, uploading: true }
        ctx.commit(SET_ATTACH, attach)

        uploadS3(file, isPublic, 'upload', (progress) => {
          attach.progress = Number((progress * 100).toFixed(1))
          ctx.commit(SET_ATTACH, attach)
        }).then((item) => {
          attach.fileUrl = item.key
          delete attach.progress

          delete attach.uploading
          if (!fileExceeded) {
            ctx.commit(SET_ATTACH, attach)
          } else {
            ctx.dispatch('setInput', { message: item.url, refId, refType })
            ctx.commit(SET_EXCEEDED, true)
            ctx.commit(DEL_ATTACH, attach)
          }
        }).catch((err) => {
          console.log(err)
          ctx.commit(DEL_ATTACH, attach)
        })
      }
    },

    removeAttach (ctx, item) {
      ctx.commit(DEL_ATTACH, item)
    }
  },

  mutations: {
    [SET_INPUT]: (state, { refType, refId, message }) => {
      if (!state.input[refType]) state.input[refType] = {}
      state.input[refType][refId] = message
    },

    [SET_EXCEEDED]: (state, exceeded) => {
      state.isFileExceeded = exceeded
    },

    [SET_ATTACH]: (state, attach) => {
      const files = Array.isArray(state.files) ? [...state.files] : []
      const index = files.findIndex(findByRef(attach))
      index === -1 ? files.push(attach) : files.splice(index, 1, attach)
      state.files = files
    },

    [DEL_ATTACH]: (state, attach) => {
      const files = Array.isArray(state.files) ? [...state.files] : []
      const index = files.findIndex(findByRef(attach))
      if (index === -1) return
      files.splice(index, 1)
      state.files = files
    }
  }
}
const newNotification = (title, body) => {
  return new Notification(title, { body })
}

const findByRef = (attach) => (file) => (
  file.refId === attach.refId && file.refType === attach.refType && file.id === attach.id
)
const typeMaxSize = ({ size, type }) => {
  return size > typeSize(type)
}
const typeSize = (type) => {
  if (type.includes('image')) return 5000000
  if (type.includes('audio')) return 16000000
  if (type.includes('video')) return 16000000
  return 100000000
}
